import type { Tool } from '@hana/ask-core';

/** Sổ công cụ: mỗi vùng đăng ký công cụ đọc của mình; worker `ask` lấy cả sổ. Tên công cụ là duy nhất toàn sổ. */
export type ToolRegistry = {
  register(app: string, tools: Tool[]): void;
  /** Công cụ của một vùng, hoặc của mọi vùng khi bỏ trống. */
  list(app?: string): Tool[];
  apps(): string[];
};

export function createRegistry(): ToolRegistry {
  const byApp = new Map<string, Tool[]>();
  const names = new Map<string, string>();
  return {
    register(app, tools) {
      for (const t of tools) {
        if (t.kind !== 'read' && t.kind !== 'propose') throw new Error(`Công cụ ${t.name}: loại không hợp lệ`);
        const owner = names.get(t.name);
        if (owner !== undefined) throw new Error(`Công cụ ${t.name} đã đăng ký bởi ${owner}`);
      }
      const seen = new Set<string>();
      for (const t of tools) {
        if (seen.has(t.name)) throw new Error(`Công cụ ${t.name} trùng trong cùng lần đăng ký`);
        seen.add(t.name);
      }
      for (const t of tools) names.set(t.name, app);
      byApp.set(app, [...(byApp.get(app) ?? []), ...tools]);
    },
    list: (app) => (app ? [...(byApp.get(app) ?? [])] : [...byApp.values()].flat()),
    apps: () => [...byApp.keys()],
  };
}

/** Sổ dùng chung của một bản dựng. */
export const registry = createRegistry();
export const register = registry.register;
